import type { IconData } from '@stacksjs/iconify-core'

export const basicArrowsDownLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M13.04 15.84H.16V2.96l3.36 3.377L9.68.16l6.16 6.16l-6.16 6.16z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicArrowsDownLeft
